var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 5,
    fill: "#23D2FF",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9083 10.974C12.7175 10.974 14.1839 9.50741 14.1839 7.69829C14.1839 5.88926 12.7175 4.42261 10.9083 4.42261C9.09922 4.42261 7.63257 5.88926 7.63257 7.69829C7.63396 9.5068 9.09974 10.9726 10.9083 10.974ZM10.9083 4.97779C12.4108 4.97779 13.6287 6.19575 13.6287 7.69829C13.6287 9.20083 12.4108 10.4188 10.9083 10.4188C9.40588 10.4188 8.18776 9.20083 8.18776 7.69829C8.19028 6.19688 9.40684 4.98023 10.9083 4.97779Z",
    fill: "#1E1F6E",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9082 11.793C9.48421 11.793 8.15998 12.3454 7.17735 13.3503C6.18072 14.3691 5.63379 15.7598 5.63379 17.2701C5.63422 17.4232 5.75831 17.5472 5.91143 17.5477H15.9051C16.0583 17.5472 16.1822 17.4232 16.1826 17.2701C16.1826 15.7627 15.6358 14.3691 14.6392 13.3531C13.6565 12.3482 12.3324 11.793 10.9082 11.793ZM6.19462 16.9925C6.25571 15.7378 6.74147 14.5912 7.57151 13.7417C8.44874 12.845 9.63411 12.351 10.9055 12.351C12.1769 12.351 13.3623 12.845 14.2394 13.7417C15.0722 14.5912 15.5553 15.7378 15.6164 16.9925H6.19462Z",
    fill: "#1E1F6E",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.acfe9b78d08a283db61b88fdd85f3b47.svg";
export { ForwardRef as ReactComponent };